package com.macrofocus.eflux.ui.perspective

import com.macrofocus.eflux.DataLoader
import com.macrofocus.eflux.components.blurBackground
import i18next.useTranslation
import mui.material.Paper
import mui.material.styles.Theme
import mui.material.styles.useTheme
import mui.system.SxProps
import mui.system.sx
import org.mkui.component.CPComponent
import org.mkui.react.useProperty
import react.FC
import react.Props
import web.cssom.Overflow
import web.cssom.Position
import web.cssom.px

class AboutPerspective(private val dl: DataLoader) : CPComponent {
    override val nativeComponent: FC<*> = FC<Props> {
        val theme = useTheme<Theme>()
        val (t, _) = useTranslation()

        val (getExpertMode, _) = useProperty(dl.exportMode)

        val customBackground: (SxProps<Theme>) -> Unit = { it ->
            it.blurBackground(theme)
        }

        Paper {
            sx {
                position = Position.absolute
                top = 0.px
//                bottom = 0.px
                left = 0.px
                right = 0.px
                overflowY = Overflow.scroll

                customBackground(this)
            }

            About {}
        }
    }

}